import { render, staticRenderFns } from "./SimilarJobsList.vue?vue&type=template&id=3682cd86&"
import script from "./SimilarJobsList.vue?vue&type=script&lang=js&"
export * from "./SimilarJobsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports